import React from 'react'
import { Button, Text, View } from 'reshaped'

type MenuLinkProps = {
  children: React.ReactNode
  icon: React.ReactElement
  onClick?: () => void
  href?: string
}

export function MenuLink({ children, href, icon, onClick }: MenuLinkProps) {
  return (
    <Button
      href={href}
      variant="ghost"
      size="large"
      color="neutral"
      fullWidth={true}
      attributes={{ style: { justifyContent: 'flex-start' } }}
      onClick={onClick}
    >
      <View direction="row" align="center" gap={3}>
        {icon}
        <Text variant="body-2" weight="semibold" color="primary">
          {children}
        </Text>
      </View>
    </Button>
  )
}
